export default __webpack_public_path__ + "static/media/dimitris.c1311b2f.webp";